<style scoped lang="less">
.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #38b346;

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #38b346;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.choiostitlelefts {
		display: flex;
		align-items: center;
	}
	.chiocetext {
		display: flex;
		margin-left: 20px;
		font-size: 16px;
		align-items: center;

		.chiocetextlist {
			display: flex;
			align-items: center;
			p {
				margin: 0 10px;
				cursor: pointer;
			}

			.avtives {
				color: #fff;
				padding: 5px 10px;
				background-color: #38b346;
				border-radius: 5px;
			}
		}
	}
}

.errlist {
	border-top: 2px solid #38b346;
	padding: 20px 10px;
	background-color: #fff;
}

/deep/ .el-collapse-item__header {
	background-color: #eff2fa;
}
/deep/ .is-active {
	background-color: #71acfe;
	color: #fff;
	.titletextdas {
		p {
			color: #fff;
		}
	}
}

.titletextdas {
	display: flex;
	align-items: center;
	margin-left: 10px;

	p {
		margin-left: 10px;
		font-size: 15px;
	}
}

.textdas {
	margin: 10px 0;
	margin-left: 80px;

	.textlisg {
		font-size: 16px;
	}

	.analyze {
		display: flex;
		justify-content: space-between;
		font-size: 15px;
		align-items: center;

		div {
			display: flex;
			align-items: center;
			cursor: pointer;
			margin-right: 40px;

			p {
				margin: 0 10px;
				font-size: 16px;
				text-decoration: underline;
			}
		}
	}
}

.elpagian {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 40px 0;
}
</style>
<template>
	<div>
		<titles titlename="我的错题" titlecontent="这里可以看到我的错题一些信息" :mbx="paths"></titles>
		<div class="choiostitle">
			<div class="choiostitlelefts">
				<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
				<div class="chiocetext">
					<p>题目类型：</p>
					<div class="chiocetextlist">
						<p v-for="(item, index) in textlists" :class="{ avtives: isactivve == index }" @click="changetextli(index)" :key="item.SQT_GUID">{{ item.SQT_Name }}</p>
					</div>
				</div>
			</div>

			<!-- <div class="choiostitleright col-xs-4 col-sm-4 col-md-4 col-lg-4">
				<el-input placeholder="请输入查找题目内容" v-model="input" clearable></el-input>
			</div> -->
		</div>

		<div class="errlist">
			<div style="height: 40vh;padding: 40px 0;" v-if="lists.length == 0"><el-empty iconSize="40" textSize="20" text="暂无课程信息"></el-empty></div>
			<el-collapse accordion>
				<el-collapse-item v-for="(item, index) in lists" :key="item.CW_GUID" style="margin: 10px 0;">
					<template slot="title">
						<div class="titletextdas">
							<el-tag effect="dark" :type="item.SQT_Name == '单选题' ? 'warning' : item.SQT_Name == '多选题' ? 'success' : ''">{{ item.SQT_Name }}</el-tag>
							<p>{{ index + 1 }}、{{ item.SQB_Question }}</p>
						</div>
					</template>
					<div class="textdas">
						<p class="textlisg" v-for="(its, idx) in item.Questionoptions" :key="its.SQO_GUID">
							<span
								style="display: inline-block;width: 20px;height: 20px;border-radius: 50%;border: 1px solid #ccc;"
								:style="{ background: its.SQO_IsAnswer ? '#4be16e' : '#fff' }"
							></span>
							<!-- v-if="its.SQO_IsAnswer || its.IsSelect" -->
							<!-- <span
								v-if="!its.SQO_IsAnswer && its.IsSelect"
								style="display: inline-block;width: 20px;height: 20px;border-radius: 50%;border: 1px solid #ccc;"
								:style="{ background: its.IsSelect ? 'red' : '#fff' }"
							></span>
							<span
								v-if="!its.IsSelect && !its.SQO_IsAnswer"
								style="background:#fff; display: inline-block;width: 20px;height: 20px;border-radius: 50%;border: 1px solid #ccc;"
							></span> -->

							{{ its.SQO_OptionName }}
						</p>

						<div style="font-size: 15px;color:rgb(0, 0, 255);">
							<span style="color: #000;">标准答案：</span>
							{{ getisanswer(item.Questionoptions) }}
						</div>
						<div style="font-size: 15px;color:red;">
							<span style="color: #000;">我的选项：</span>
							{{ getiunnotes(item.Questionoptions) }}
						</div>

						<div class="analyze">
							<p>解析：{{ item.SQB_QuestionParsing }}</p>
							<div>
								<p @click="chengesc(item.IsMyCollect, item.SQB_GUID)">
									<span v-if="!item.IsMyCollect" class="el-icon-star-off"></span>
									<span v-if="item.IsMyCollect" style="font-size: 18px;color: #f59a23;" class="el-icon-star-on"></span>
									{{ item.IsMyCollect ? '取消收藏' : '收藏题目' }}
								</p>
								<el-popconfirm
									confirm-button-text="好的"
									cancel-button-text="不用了"
									icon="el-icon-info"
									icon-color="red"
									title="确定移除该题目吗？"
									@confirm="delecttext(item.SQB_GUID)"
								>
									<p slot="reference">
										<span style="color: red;" class="el-icon-delete-solid"></span>
										移除错题
									</p>
								</el-popconfirm>
							</div>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>

			<div class="elpagian">
				<el-pagination
					@current-change="changecurr"
					background
					hide-on-single-page
					layout="prev, pager, next"
					:page-size="pagesobj.pageSize"
					:total="totalall"
					:current-page="pagesobj.pageIndex"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { GetCollectWroteList, getGetQuetype, AddMyCollects, DeleteMyCollect, DeleteCollectwrote } from '@/request/api/homesview/yunhomes/yunhom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			radio: '',
			textlists: [
				{
					SQT_GUID: 0,
					SQT_Name: '所有'
				}
			],
			isactivve: 0,
			// 标题
			paths: [
				{
					path: '/usercenter/Myerrtexts',
					name: '我的错题'
				}
			],
			input: '',
			totalall: 100,
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				SQT_GUID: '',
				Inspectionlevel: '',
				PR_GUID: '',
				ProfessionalID: ''
			},
			lists: []
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getlist();
	},
	methods: {
		getiunnotes(list) {
			let OptionName = list.find(its => its.IsSelect);
			let optsname = '暂无选择';
			if (OptionName) {
				optsname = OptionName.SQO_OptionName;
			}
			return optsname;
		},
		getisanswer(list) {
			let OptionName = list.find(its => its.SQO_IsAnswer).SQO_OptionName;
			// console.log(OptionName)
			return OptionName ?? '';
		},
		chengesc(ibol, id) {
			let qbgid = {
				SQB_GUID: id
			};
			if (!ibol) {
				AddMyCollects(qbgid).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.getlist();
					}
				});
			} else {
				DeleteMyCollect(qbgid).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.getlist();
					}
				});
			}
		},
		delecttext(id) {
			let qbgid = {
				SQB_GUID: id
			};
			DeleteCollectwrote(qbgid).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getlist();
				}
			});
		},
		changetextli(i) {
			this.isactivve = i;
			// console.log(this.isactivve);
			this.pagesobj.pageIndex = 1;
			this.pagesobj.SQT_GUID = this.textlists[i].SQT_GUID;
			if (i == 0) {
				this.pagesobj.SQT_GUID = '';
			}
			this.getlist();
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getlist();
		},
		getlist() {
			getGetQuetype().then(res => {
				if (res.data.code > 0) {
					if (this.textlists.length == 1) {
						this.textlists = [...this.textlists, ...res.data.data];
					}
				}
			});

			GetCollectWroteList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					this.lists = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>
